<template>
  <div class="downloads">
    <spinner v-if="loading" />
    <breadcrumb :links="breadcrumb" />
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">File download</span>
      </heading-wrap>
       <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
                <h5 class="card-title">Status: <span v-if="downloadStatus" class="label label-pill label-success">
                    Ready
                </span>
                <span v-else class="label label-pill label-warning">
                    {{ download.status }}
                </span>
                </h5>
                <h5 class="card-title">Date Created: {{ download.date_created.value | formatDate }} | requested By {{ download.name }}</h5>
                <button v-if="downloadStatus" @click="downloadFile(download.url)" class="btn btn-lg btn-primary"><i class="fa fa-download"></i> Download</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import Button from '../../components/Button/button.vue'
import ButtonCta from '@/components/Button/button'
import Modal from '@/components/Modal/modal'
import SlotTable from '@/components/Table/table'
import Spinner from '@/components/SpinnerIcon/spinner'
import Breadcrumb from '@/components/Breadcrumb/breadcrumb'
import {notificationMixin} from '@/mixins/notificationMixin'
import {modalMixin} from '@/mixins/modalMixin'
import {downloadMixin} from '@/mixins/downloadMixin'

import { MEDIA_URL } from '@/config'

// import { assoc, map } from 'ramda'

export default {
  name: 'Downloads',
  mixins: [notificationMixin, downloadMixin, modalMixin],
  components: {
    HeadingWrap,
    ButtonCta,
    Modal,
    SlotTable,
    Spinner,
    Breadcrumb,
    Button
  },
  props: {
    tableData: Array
  },
  data: () => ({
    download: Object
  }),
  mounted () {
    this.getDownload(this.downloadEntryId).then((response) => {
      this.finishLoading()
      this.download = response
    })
  },
  computed: {
    downloadEntryId () {
      return this.$route.params.id
    },
    downloadStatus () {
      if (this.download.status === 'success') {
        return true
      } else {
        return false
      }
    },
    breadcrumb () {
      if (this.download.creative) {
        return [
          {
            name: this.download.campaign.name,
            path: `campaigns/${this.download.campaign.hash_id}`
          },
          {
            name: this.download.campaign.name,
            path: `creatives/${this.download.campaign.hash_id}/bulk`
          },
          {
            name: 'Download file',
            path: '',
            active: true
          }
        ]
      }
    }
  },
  methods: {
    downloadFile (file) {
      window.open(`${MEDIA_URL}${file}`, '_blank').focus()
    }
  }
}
</script>

<style lang="scss">
  .tags {
    .headingWrap__title {
      width:75%;
    }
    .debugInfo {
      display: none;
      border: 1px solid grey;
      background: black;
      color:limegreen;
      padding:20px;
      word-wrap: break-word;
      border-radius:5px;
    }
    .debugInfo h3 {
      color:pink;
    }
    .showDebug {
      display: block;
    }
    pre {
      white-space: unset;
    }
    pre code {
      color: #c7254e;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/downloads/file.vue